export default __webpack_public_path__ + "media/images/logo/logo-light-is-logo-e3113165e2681a4c7498658c4f94df06.png";